import React, { useCallback, useContext, useState } from 'react';
import { View } from 'react-native';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { AuthContext } from 'app/src/contexts/AuthContext';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import {
  Fields,
  defaultValues,
  prepareInput,
} from 'app/src/elements/hookForms';

import { specialAccount } from '../Txns/utils';

import { CREATE_FEE_TYPE } from './queries';

const SPECIAL_USES = [
  { value: 'buy', label: 'Buy Fee' },
  { value: 'sell', label: 'Sell Fee' },
  { value: 'listing', label: 'Listing Fee' },
];

export const FIELDS = {
  name: {
    rules: { required: true },
  },
  chargeAccountId: {
    label: 'P&L Account',
    type: 'account',
    hint: 'Income from fees of this type will show up on the P&L ' +
      'under this account',
    rules: { required: true },
    preferredTypes: ['Income'],
  },
  buyerChargeAccountId: {
    label: 'P&L Account For Buyer paid Fees',
    type: 'account',
    hint: 'Optional, if a different account should be used for buyer paid fees',
    preferredTypes: ['Income'],
    blank: 'null',
  },
  customShortName: {
    label: 'Short Name',
    hint: 'Optional, may be used on some reports to use less header space',
  },
  special: {
    label: 'Special Use Designation',
    select: SPECIAL_USES,
    hint: (
      'In most cases, this can be left blank. It is used to identify ' +
      'fee types that have special back-end uses.'
    ),
    blank: 'null',
  },
  markup: {
    label: 'Allow Setting Markups',
    type: 'boolean',
  },
};

const NewFeeType = ({ setShowModal, refetch }) => {
  const { accounts } = useContext(AuthContext);

  const [formStatus, setFormStatus] = useState();

  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: defaultValues({
      fields: FIELDS,
      resource: {
        markup: true,
        chargeAccountId: (
          specialAccount({ accounts, special: 'default_fee_income' }).value
        )
      }
    })
  });

  const [createFeeType] = useMutation(CREATE_FEE_TYPE, {
    onCompleted: () => {
      refetch();
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setFormStatus('submitting');
    createFeeType({ variables: prepareInput(input, FIELDS) });
  });

  return (
    <View>
      <Fields
        fields={FIELDS}
        control={control}
        errors={errors}
      />

      <ButtonGroup>
        <Button label="Create Fee Type" onPress={handleSubmit(onSubmit)} />
      </ButtonGroup>
    </View>
  );
};

export default NewFeeType;
